// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import Vue from 'vue'
import Vuex from 'vuex'

import images from './modules/images'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    images,
    user
  },
  strict: debug
})




// WEBPACK FOOTER //
// ./src/store/index.js